import type { Action, GenericDisplayOptions } from "../actions.types";
import { ACTION_STATUS } from "../actions.constants";
import { isOrgAdminAction } from "./isOrgAdminAction";

/**
 * Check if an action should be visible on the dashboard.
 * An action is visible if:
 * - It's not hidden via display_options
 * - It belongs to a program phase OR is an org admin action
 */
export function isActionVisibleOnDashboard(action: Action): boolean {
  const opts = action.display_options as GenericDisplayOptions | null;

  // Hidden from dashboard entirely
  if (opts?.hide_from_dashboard === true) {
    return false;
  }

  // Hidden when completed
  if (
    opts?.hide_from_dashboard_when_completed === true &&
    action.current_status?.name === ACTION_STATUS.COMPLETED
  ) {
    return false;
  }

  // Action must belong to a phase or be an org admin action to be displayed
  // Actions without a program_phase and not org admin won't appear anywhere
  const hasProgramPhase = action.program_phase !== null;
  const isOrgAdmin = isOrgAdminAction(action);

  if (!hasProgramPhase && !isOrgAdmin) {
    return false;
  }

  return true;
}
